var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('base-input',{attrs:{"addon-left-icon":"ni ni-calendar-grid-58"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var focus = ref.focus;
var blur = ref.blur;
return _c('flat-picker',{staticClass:"form-control datepicker",attrs:{"config":{allowInput: true}},on:{"on-open":focus,"on-close":blur},model:{value:(_vm.simple),callback:function ($$v) {_vm.simple=$$v},expression:"simple"}})}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }